import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'hr-assistant-icon',
  templateUrl: './hr-assistant-icon.component.html',
  styleUrl: './hr-assistant-icon.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': 'size()',
    '[style.min-width.px]': 'size()',
    '[style.height.px]': 'size()',
    '[style.min-height.px]': 'size()',
  },
})
export class HrAssistantIconComponent {
  public size = input.required<40 | 32 | 24>();
}
